
import { HomeIcon, LockClosedIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Heading, Text } from '@radix-ui/themes';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Flex align="center" justify="center" py="8" px="4">
            <Card size="3" variant="surface" style={{ maxWidth: '480px', width: '100%' }}>
                <Flex direction="column" align="center" gap="4" py="4" px="2">
                    <Flex
                        align="center"
                        justify="center"
                        style={{
                            width: '56px',
                            height: '56px',
                            borderRadius: 'var(--radius-4)',
                            backgroundColor: 'var(--red-3)',
                            color: 'var(--red-11)',
                        }}
                    >
                        <LockClosedIcon width="28" height="28" />
                    </Flex>

                    <Flex direction="column" align="center" gap="2">
                        <Text size="2" color="gray" weight="medium">Acesso negado</Text>
                        <Heading size="5" align="center">Não tem permissão para aceder a esta página</Heading>
                        <Text size="2" color="gray" align="center">
                            Se considera que se trata de um engano, contacte o administrador do sistema
                            para lhe serem atribuídas as permissões necessárias.
                        </Text>
                    </Flex>

                    <Button type="button" onClick={() => navigate('/')}>
                        <HomeIcon /> Voltar ao painel
                    </Button>
                </Flex>
            </Card>
        </Flex>
    );
};

export default Unauthorized;
